<template>
  <el-config-provider :locale="zhCn">
    <RouterView />
  </el-config-provider>
</template>
<script setup lang="ts">
// @ts-ignore
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';

if (navigator?.platform?.toUpperCase()?.indexOf('MAC') >= 0) {
  document.body.classList.add('mac-os');
}
</script>
